import { createContext, useContext, useMemo, useCallback } from 'react';
import { getDefaultLocale } from 'utils/locale';

const LOCALE_STORAGE_KEY = 'locale';
const SUPPORTED_LOCALES = ['pl', 'en'];

const getStoredLocale = () => {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  return SUPPORTED_LOCALES.includes(stored) ? stored : getDefaultLocale();
};

const LocaleContext = createContext();

export const LocaleProvider = ({ children }) => {
  const locale = getStoredLocale();

  const setLocale = useCallback((nextLocale) => {
    if (!SUPPORTED_LOCALES.includes(nextLocale)) return;
    if (nextLocale === getStoredLocale()) return;
    localStorage.setItem(LOCALE_STORAGE_KEY, nextLocale);
    window.location.reload();
  }, []);

  const value = useMemo(() => ({ locale, setLocale }), [locale, setLocale]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => useContext(LocaleContext);
